(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';

    class HeroSlideshow extends HTMLElement {
      constructor() {
        super();
        this.slides = [];
        this.currentIndex = 0;
        this.autoplayInterval = null;
        this.isPlaying = false;
        this.cycleSpeed = 5000;
      }

      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('hero-slide'));
        this.prevButton = this.querySelector('.hero__nav-arrow--prev');
        this.nextButton = this.querySelector('.hero__nav-arrow--next');

        this.cycleSpeed = (parseInt(this.dataset.cycleSpeed, 10) || 5) * 1000;

        if (this.slides.length <= 1) return;

        this.bindEvents();

        if (this.hasAttribute('auto-play')) {
          this.startAutoplay();
        }
      }

      disconnectedCallback() {
        this.stopAutoplay();
      }

      bindEvents() {
        if (this.prevButton) {
          this.prevButton.addEventListener('click', () => this.prev());
        }
        if (this.nextButton) {
          this.nextButton.addEventListener('click', () => this.next());
        }

        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.prev();
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.next();
          }
        });
      }

      goToSlide(index) {
        if (index === this.currentIndex || index < 0 || index >= this.slides.length) return;

        const currentSlide = this.slides[this.currentIndex];
        const nextSlide = this.slides[index];

        currentSlide.setAttribute('hidden', '');
        nextSlide.removeAttribute('hidden');

        this.currentIndex = index;

        if (this.isPlaying) {
          this.restartAutoplayTimer();
        }
      }

      next() {
        const nextIndex = (this.currentIndex + 1) % this.slides.length;
        this.goToSlide(nextIndex);
      }

      prev() {
        const prevIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
        this.goToSlide(prevIndex);
      }

      startAutoplay() {
        if (this.slides.length <= 1) return;

        this.isPlaying = true;

        this.autoplayInterval = setInterval(() => {
          this.next();
        }, this.cycleSpeed);
      }

      stopAutoplay() {
        this.isPlaying = false;

        if (this.autoplayInterval) {
          clearInterval(this.autoplayInterval);
          this.autoplayInterval = null;
        }
      }

      restartAutoplayTimer() {
        if (this.autoplayInterval) {
          clearInterval(this.autoplayInterval);
        }

        this.autoplayInterval = setInterval(() => {
          this.next();
        }, this.cycleSpeed);
      }
    }

    class HeroSlide extends HTMLElement {
      constructor() {
        super();
      }
    }

    if (!customElements.get('hero-slideshow')) {
      customElements.define('hero-slideshow', HeroSlideshow);
    }

    if (!customElements.get('hero-slide')) {
      customElements.define('hero-slide', HeroSlide);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
